module.exports = __webpack_public_path__ + "img/sem-multa1.16324c69.svg";